/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRole {
  Owner = 'OWNER',
  Admin = 'ADMIN',
  EventAdmin = 'EVENT_ADMIN',
  Cashier = 'CASHIER',
  Volunteer = 'VOLUNTEER',
  Member = 'MEMBER'
}
